import React from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts';
import '../styles/PosterCard.css';

const PosterCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  
  // Первое изображение из строки images (разделены запятой) или preViewImg
  const firstImage = product.images?.split(',')[0] || product.preViewImg;

  return (
    <div className="PosterCard" onClick={onClick}>
      <div className="posterCardImageContainer">
        <img className='posterCardImage'
          src={`${constants.serverUrl}${firstImage}`} 
          alt={product.title} 
        />
      </div>
      <p className="posterCardTitle">{product.title}</p>
      <p className="posterCardPrice">{product.price} ₽</p>
    </div>
  );
};

export default PosterCard;